import React, { useState } from "react"
import { Link } from "react-router-dom"

const Navbar = () => {
  // Toogle Menu
  const [MobileMenu, setMobileMenu] = useState(false)
  return (
    <>
      <header className='header'>
        <div className='container d_flex'>
          {/* <div className='catgrories d_flex'>
            <span class='fa-solid fa-border-all'></span>
            <h4>
              Categories <i className='fa fa-chevron-down'></i>
            </h4>
          </div> */}

          <div className='navlink'>
            <ul className={MobileMenu ? "nav-links-MobileMenu" : "link f_flex capitalize"} onClick={() => setMobileMenu(false)}>
              {/*<ul className='link f_flex uppercase {MobileMenu ? "nav-links-MobileMenu" : "nav-links"} onClick={() => setMobileMenu(false)}'>*/}
              <li>
                <Link to='/'>home</Link>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=6fab35bd7d8a2cc88839346536d19004&camp=3638&creative=24630&node=976419031">Electronics</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=53fec1c14faa9f66cbb0b862f0c7b1ae&camp=3638&creative=24630&node=976389031">Books</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=bbbac07e32cf3a510dcf5fce66fd347a&camp=3638&creative=24630&node=1983396031">Shoes</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=0bcc390c0cdb018f0b88be92c9620303&camp=3638&creative=24630&node=1350385031">Health &amp; Beauty</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=9cd492ec49c1d0d925ebba76522dd6c9&camp=3638&creative=24630&node=2454181031">Pet Supplies</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=97d6766535f6f7a3458a4bdcdba262e7&camp=3638&creative=24630&node=976442031">Kitchen &amp; Housewares</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=0090d38bb17edf2969c3c3e93b1d22d5&camp=3638&creative=24630&node=976416031">Movies &amp; TV</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=bf89fef3ece5944b1716780cf5d90905&camp=3638&creative=24630&node=1350387031">Watches</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=7bb23e2e8060e4c1586b8d99fbc5a4ae&camp=3638&creative=24630&node=976392031">Computers</a>
              </li>
              <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=3f4e345e72a1716896c941d6e5826e3a&camp=3638&creative=24630&node=1951048031">Jewelry</a>
              </li>
              {/* <li>
              <a target="_blank" href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=c4afe2fea43757fdb3f7eeb094ebf91b&camp=3638&creative=24630&node=2454169031">Luggage</a>
              </li> */}
              <li>
                <a href="https://t.me/hoottdeals" style={{color:"rgb(233, 69, 96)", fontWeight:"bold"}}>Join Now</a>
              </li>
            </ul>

            <button className='toggle' onClick={() => setMobileMenu(!MobileMenu)}>
              {MobileMenu ? <i className='fas fa-times close home-btn'></i> : <i className='fas fa-bars open'></i>}
            </button>
          </div>
        </div>
      </header>
    </>
  )
}

export default Navbar
